import { Channel, MetricAgentView, MetricAggregateView, MetricMerchantView, Pricing } from '@nemuru-eng/js-api-client';
import React, { useContext } from 'react';

import { DocumentationUploadFile } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/types/DocumentationUploadFile';
import { QueryBuilder } from '@/components/modules/Metrics/shared/entities/QueryBuilder';
import { PricingsListEntity } from '@/components/modules/PricingsList/entities/PricingsListEntity';
import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';
import { updateOperationsContext } from '@/contexts/OperationsContext/actions/updateOperationsContext';

export const operationsState = {
  documentationToUpload: [] as DocumentationUploadFile[],
  metricsRefreshToken: 0 as number,
  metricAggregateQueryBuilder: undefined as QueryBuilder | undefined,
  metricAggregateViews: undefined as MetricAggregateView[] | undefined,
  metricMerchantQueryBuilder: undefined as QueryBuilder | undefined,
  metricMerchantViews: undefined as MetricMerchantView[] | undefined,
  metricAgentQueryBuilder: undefined as QueryBuilder | undefined,
  metricAgentViews: undefined as MetricAgentView[] | undefined,
  pricing: undefined as Pricing | undefined,
  pricingsListEntity: undefined as PricingsListEntity | undefined,
  lastViewedLoanId: undefined as string | undefined,
  lastViewedMerchantId: undefined as string | undefined,
  lastViewedPayoutId: undefined as string | undefined,
  lastViewedCheckoutSessionId: undefined as string | undefined,
  lastViewedSinglePaymentId: undefined as string | undefined,
  lastViewedReportId: undefined as string | undefined,
  selectedReport: undefined as ReportsListRowProps['row'] | undefined,
  selectedChannel: undefined as Channel | undefined,
};

const actionsDefinitions = (setStateById: (id: string, stateChange: stateChangeInOperationsContext) => void) => ({
  updateOperationsContext: updateOperationsContext(setStateById),
});

const OperationsContext = React.createContext({
  state: operationsState,
  actions: actionsDefinitions(() => () => {}),
});

export type action = (setState: setStateInOperationsContext, actionId: string) => () => void;

export type stateChangeInOperationsContext = (prevState: typeof operationsState) => typeof operationsState;
export type setOperationsStateById = (id: string, stateChange: stateChangeInOperationsContext) => void;
export type setStateInOperationsContext = React.Dispatch<stateChangeInOperationsContext>;

export type operationActions = typeof actionsDefinitions;

export const useOperationsContext = () => useContext(OperationsContext);

export function OperationsContextProvider(props) {
  const [state, setState] = React.useState(operationsState);
  const setStateById: setOperationsStateById = (_, stateChange) => {
    setState(stateChange);
  };

  const actions = actionsDefinitions(setStateById);
  return <OperationsContext.Provider value={{ state, actions }}>{props.children}</OperationsContext.Provider>;
}
